import script from "./PointsBoard.vue?vue&type=script&setup=true&lang=js"
export * from "./PointsBoard.vue?vue&type=script&setup=true&lang=js"

import "./PointsBoard.vue?vue&type=style&index=0&id=9106705a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9106705a"]])

export default __exports__